import { useTranslation } from 'react-i18next'

import { EMPTY_LIST } from '../../../../constants/common'
import { getQaSelector } from '../../../../utils/common'
import { Link } from '../../../Link'
import { getViewingProfileLink } from '../../../RentalPortalViewing'
import Text from '../../../Text'
import { Widget } from '../../../Widget'
import { useViewingProfileContext } from '../RentalPortalViewingProfile.hooks'

import { QA_NAME_VIEWING_PROFILE_RESCHEDULE_HISTORY } from './RentalPortalViewingProfileRescheduleHistory.constants'
import { getViewingRescheduleHistoryLabel } from './RentalPortalViewingProfileRescheduleHistory.utils'

import * as styles from './RentalPortalViewingProfileRescheduleHistory.module.css'

function RentalPortalViewingProfileRescheduleHistory({ locale, timezone }) {
  const { t } = useTranslation()

  const { isInitiated, viewingData } = useViewingProfileContext()

  const history = viewingData?.reschedule_history ?? EMPTY_LIST

  return history.length === 0 ? null : (
    <Widget
      {...getQaSelector({ value: QA_NAME_VIEWING_PROFILE_RESCHEDULE_HISTORY })}
      headerProps={{ contentProps: { actionsProps: { EditButton: null } } }}
      isSkeleton={!isInitiated}
      title={t('RentalPortal.ViewingProfileRescheduleHistoryTitleKey')}
    >
      <div className={styles.list}>
        {history.map(item => (
          <div className={styles.row} key={item.id}>
            <Text isSecondary>
              {getViewingRescheduleHistoryLabel({ item, locale, timezone })}
            </Text>
            <Link to={getViewingProfileLink(item.id)}>
              {t('RentalPortal.ViewingProfileRescheduleHistoryOpenKey')}
            </Link>
          </div>
        ))}
      </div>
    </Widget>
  )
}

export default RentalPortalViewingProfileRescheduleHistory
